import { SET, FETCH, FETCH_SUCCESS, FETCH_FAILURE } from './actionTypes';
import IState from '../../models/state.model';
import IAction from '../../models/action.model';


const defaultStore: any = {
  path: '',
}

export default function user(
  state: IState = defaultStore,
  action: any,
) {
  switch (action.type) {
    case SET: 
      return {
        ...state,
        path: action.payload
      };

    case FETCH: 
      return {
        ...state
      };
    
    case FETCH_SUCCESS: 
      return {
        ...state,
        path: action.payload
      }
    
    case FETCH_FAILURE: 
      return {
        ...state
      }

    default:
      return state;
  }
}
